import { getComponent } from '../utils'
import MultiTabLayout from '@/layouts/multi-tab-layout.vue'
import { get_config } from '@/config'

const config = get_config()

import MainLayout from '@/layouts/main-layout.vue'
import PublicLayout from '@/layouts/public-layout.vue'
import { auth_routes } from './auth-routes'
import { public_routes } from './public-routes'
import { user_routes } from './user-routes'
import { org_routes } from './org-routes'
import { account_routes } from './account-routes'
import { org_admin_routes } from './org-admin-routes'
import { super_admin_routes } from './super-admin-routes'
import type { RouteRecordRaw } from 'vue-router'
import { project_routes } from './project-routes'
import { dashboard_routes } from './dashboard-route'
import { team_routes } from './team-routes'
import { crew_connect_routes } from './crew-connect-routes'

const Layout = config.is_multitab ? MultiTabLayout : MainLayout

export const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: '/',
    name: 'index',
    redirect: `/home`,
    children: [
      // Public routes
      ...public_routes,

      // Crew Connect routes
      ...crew_connect_routes,

      // Auth routes
      ...auth_routes,

      // Private routes

      // Dashboard
      ...dashboard_routes,

      // PROJECT ROUTES
      ...project_routes,

      // USER ROUTES
      ...user_routes,

      // TEAM ROUTES
      ...team_routes,

      // ORG ROUTES
      ...org_routes,

      // ACCOUNT ROUTES
      ...account_routes,

      // ORG ADMIN ROUTES
      ...org_admin_routes,

      // SUPER ADMIN ROUTES
      ...super_admin_routes
    ]
  },
  // ########################################
  // #            Error Routes              #
  // ########################################
  {
    path: '/:catchAll(.*)',
    component: () => getComponent(`components/errors/404.vue`),
    meta: { transition: 'fade', layout: PublicLayout, is_public: true }
  }
]
